import Vue from "vue";
import VueRouter from "vue-router";

import ProductDetailsGeneral from "../components/products/product-details-general";
import ProductDetailsCategories from "../components/products/product-details-categories";
import ProductDetailsAttributes from "../components/products/product-details-attributes";
import ProductDetailsSEO from "../components/products/product-details-seo";
import ProductDetailsShipping from "../components/products/product-details-shipping";
import ProductDetailsMarketing from "../components/products/product-details-marketing";
import ProductDetailsPricing from "../components/products/product-details-pricing-v2";
import ProductDetailsActivity from "../components/products/product-details-activity";
import ProductDetailsInventory from "../components/products/product-details-inventory";
import ProductDetailsExclusions from "../components/products/product-details-exclusions";
import ProductDetailsChannels from "../components/products/product-details-channels";
import ProductDetailsBarcodes from "../components/products/product-details-barcodes";
import ProductDetailsBundles from "../components/products/product-details-bundles";
import ProductDetailsChildren from "../components/products/product-details-children";
import ProductDetailsAssets from "../components/products/product-details-assets";
import ProductDetailsRelations from "../components/products/product-details-relations";
import ProductDetailsTagCloud from "../components/products/product-details-tag-cloud";
import ProductDetailsScheduledContent from "../components/products/product-details-scheduled-content";
import ProductDetailsProjects from "../components/products/product-details-projects";
import ProductDetailsPricingProfiles from '../components/products/product-details-pricing-profiles'

Vue.use(VueRouter);

export default new VueRouter({
    mode: "abstract",
    routes: [
        {
            path: "/",
            name: "details",
            component: ProductDetailsGeneral
        },
        {
            path: "/categories",
            name: "categories",
            props: true,
            component: ProductDetailsCategories
        },
        {
            path: "/attributes/:panelName",
            name: "attributes",
            component: ProductDetailsAttributes
        },
        {
            path: "/seo",
            name: "seo",
            component: ProductDetailsSEO
        },
        {
            path: "/shipping",
            name: "shipping",
            component: ProductDetailsShipping
        },
        {
            path: "/marketing",
            name: "marketing",
            component: ProductDetailsMarketing
        },
        {
            path: "/pricing/active",
            name: "pricing-active",
            component: ProductDetailsPricing,
            props: { title: "Active", endpoint: "active_price_records" }
        },
        {
            path: "/pricing/future",
            name: "pricing-future",
            component: ProductDetailsPricing,
            props: { title: "Future", endpoint: "future_price_records" }
        },
        {
            path: "/pricing/expired",
            name: "pricing-expired",
            component: ProductDetailsPricing,
            props: { title: "Expired", endpoint: "expired_price_records" }
        },
        {
            path: '/pricing-profiles',
            name: 'pricing-profiles',
            component: ProductDetailsPricingProfiles,
            props: { title: 'Active', endpoint: 'pricing-profiles' }
        },
        {
            path: "/activity",
            name: "activity",
            component: ProductDetailsActivity
        },
        {
            path: "/inventory",
            name: "inventory",
            component: ProductDetailsInventory
        },
        {
            path: "/exclusions",
            name: "exclusions",
            component: ProductDetailsExclusions
        },
        {
            path: "/channels",
            name: "channels",
            component: ProductDetailsChannels
        },
        {
            path: "/barcodes",
            name: "barcodes",
            component: ProductDetailsBarcodes
        },
        {
            path: "/tags",
            name: "tags",
            component: ProductDetailsTagCloud
        },
        {
            path: "/bundle-products",
            name: "bundle-products",
            component: ProductDetailsBundles
        },
        {
            path: "/child-products",
            name: "child-products",
            component: ProductDetailsChildren
        },
        {
            path: "/assets",
            name: "assets",
            component: ProductDetailsAssets
        },
        {
            path: "/relations",
            name: "relations",
            component: ProductDetailsRelations
        },
        {
            path: "/scheduled-content",
            name: "scheduled-content",
            component: ProductDetailsScheduledContent
        },
        {
            path: "/projects",
            name: "projects",
            component: ProductDetailsProjects
        }
    ]
});
